import { Tag } from "antd";

export const TaskPriority = ({
  priority,
}: {
  priority: string | undefined;
}) => {
  if (priority == null) {
    return null;
  }

  return (
    <Tag color={priority === "urgent" ? "red" : "blue"}>
      {priority === "urgent" ? "Urgent" : "Normaal"}
    </Tag>
  );
};
